"use client";

import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const StandardProviders = dynamic(() =>
  import("./providers").then((module) => module.Providers),
);

export function ApplicationProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  if (pathname.startsWith("/embed/")) return children;
  return <StandardProviders>{children}</StandardProviders>;
}
